import React, { Suspense } from "react";
import SkeletonCardTotalList from "../sekeletons/skeleton-card-total";
import SectionDauMauCard from "./dau-mau/section-dau-mau-card";
import SectionDauMauChart from "./dau-mau/section-dau-mau-chart";
import { SkeletonMonthLineChart } from "../sekeletons/skeleton-month-line-chart";
export default function SectionDauMau() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "sale mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-4xl mb-4"
    }, "\u30E6\u30FC\u30B6\u30FC\u5206\u6790"), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 rounded-lg"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonCardTotalList, {
            length: 2,
            className: "col-span-2"
        })
    }, /*#__PURE__*/ React.createElement(SectionDauMauCard, null)), /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-6 rounded-lg"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement("div", {
            className: "h-[570px] w-full"
        }, /*#__PURE__*/ React.createElement(SkeletonMonthLineChart, null))
    }, /*#__PURE__*/ React.createElement(SectionDauMauChart, null)))));
}
